/* eslint-disable */
import * as React from 'react';
import { Spin } from 'syngenta-digital-cropwise-react-ui-kit';
import plantingIcon from 'assets/planting_icon.svg';
import harvestIcon from 'assets/harvest_icon.svg';
import tillageIcon from 'assets/tillage_icon.svg';
import applicationIcon from 'assets/application_icon.svg';
import irrigationIcon from 'assets/irrigation_icon.svg';
import observationIcon from 'assets/observation_icon.svg';
import InstanceCard from './InstanceCard';
import { Product, ResourceType } from '../types';
import { Instance } from '../types';
import { usePaginateInstances } from '../hooks/usePaginateInstances';
import { Pagination } from 'antd';
import { APIState } from '../../../models/APIState';

type InstanceCardListProps = {
  status: APIState;
  allSelected: string[];
  onHeaderClick: any;
  instances: Instance[];
  activeResourceType: ResourceType | undefined;
  containerRef: any;
  instanceProductsMap: Map<string, Product[]>;
  loadInstanceProductsStatus: APIState;
};
const InstanceCardList = ({
  status,
  allSelected,
  onHeaderClick,
  instances,
  activeResourceType,
  containerRef,

  instanceProductsMap,
  loadInstanceProductsStatus,
}: InstanceCardListProps): JSX.Element => {
  const { instancesPage, setPage, page, PAGE_SIZE, LIST_CONTAINER_SIZE } = usePaginateInstances(
    instances,
    containerRef,
  );

  const operationIconRenderer = (operation_type: string) => {
    switch (operation_type) {
      case 'HARVEST':
      case 'HARVESTING':
        return harvestIcon;
      case 'TILLAGE':
        return tillageIcon;
      case 'PLANTING':
      case 'PLANTING_AND_SOWING':
        return plantingIcon;
      case 'APPLICATION':
        return applicationIcon;
      case 'IRRIGATION':
        return irrigationIcon;
      default:
        return observationIcon;
    }
  };

  const instanceCards = instancesPage
    .filter((instance: Instance) => instance?.parent_operation?.start_date_time)
    .map((inst: Instance, index: number) => (
      <InstanceCard
        key={`${inst.id}-${index}`}
        instance={inst}
        activeResourceType={activeResourceType}
        checked={allSelected.includes(inst.id)}
        onChange={(e: any) => {
          onHeaderClick(inst, e.target.checked);
        }}
        icon={operationIconRenderer(inst.parent_operation.operation_type)}
        operationType={inst.parent_operation.operation_type}
        instanceProductsMap={instanceProductsMap}
        loadInstanceProductsStatus={loadInstanceProductsStatus}
      />
    ));

  if (status == APIState.LOADING) {
    return (
      <div data-cy="instance_card_list_loading" className="h-100% w-100% text-center mt-40">
        <Spin className="syt-default" delay={500} size="default" spinning />
      </div>
    );
  }

  return (
    <div>
      <div
        className="w-100%"
        data-cy="instance-card-container"
        style={{ minHeight: LIST_CONTAINER_SIZE }}
      >
        {instanceCards}
      </div>
      {instances.length > PAGE_SIZE && (
        <div>
          <Pagination
            data-testid="pagination"
            defaultCurrent={page}
            current={page}
            pageSize={PAGE_SIZE}
            total={instances.length}
            onChange={(e: number) => {
              setPage(e);
            }}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};

export default InstanceCardList;
